import { render } from "./accessibility.vue?vue&type=template&id=7cad3300"
import script from "./accessibility.vue?vue&type=script&lang=js"
export * from "./accessibility.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__